import React from 'react';
import { IIconProps } from '../../interfaces';
const TelegramIcon = (props: IIconProps) => {
  /*w13 h16*/
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 27 22"  fill="none" >
          <title>{props.title}</title>

          <path d="M10.4254 14.4458L10.0162 20.564C10.6002 20.564 10.8668 20.3042 11.189 19.9907L11.2164 19.9644L14.0992 17.1606L20.0963 21.5913C21.2008 22.2007 21.9967 21.8853 22.2721 20.5669L26.2086 2.01416C26.4176 1.17725 26.2447 0.577636 25.8834 0.260253C25.5465 -0.0356455 25.0455 -0.0864268 24.5367 0.145019L1.41854 9.05908C-0.159583 9.69189 -0.149817 10.5728 1.13143 10.9644L7.06405 12.8159L20.7984 4.15088C21.2896 3.854 21.7496 3.90283 21.732 4.13232C21.7262 4.20557 21.6715 4.29736 21.5533 4.40283L10.4254 14.4458Z" fill="black"/>
     </svg>

  )
};

export default TelegramIcon;